import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Education = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <path
        d="M20.3989 5.94606L8.35887 13.8061C4.49887 16.3261 4.49887 21.9661 8.35887 24.4861L20.3989 32.3461C22.5589 33.7661 26.1189 33.7661 28.2789 32.3461L40.2589 24.4861C44.0989 21.9661 44.0989 16.3461 40.2589 13.8261L28.2789 5.96606C26.1189 4.52606 22.5589 4.52606 20.3989 5.94606Z"
        stroke="#29C452"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.5591 27.0459L11.5391 36.4259C11.5391 38.9659 13.4991 41.6859 15.8991 42.4859L22.2791 44.6059C23.3791 44.9659 25.1991 44.9659 26.3191 44.6059L32.6991 42.4859C35.0991 41.6859 37.0591 38.9659 37.0591 36.4259V27.1459"
        stroke="#29C452"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M43.0986 30.886V18.886"
        stroke="#29C452"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Education.displayName = 'Education';
